// The Google Search iOS app is technically a webview and doesn't support popups.
export function isGoogleSearchApp(ua:string) {
  return /\bGSA\b/.test(ua);
}

export function isIos(ua:string) {
  ua = ua || window.navigator.userAgent;
  return /iPhone|iPod|iPad/i.test(ua);
}

export function isIosWebview(ua?:string) {
  ua = ua || window.navigator.userAgent;
  if (isIos(ua)) {
    if (isGoogleSearchApp(ua)) {
      return true;
    }
    return /.+AppleWebKit(?!.*Safari)/.test(ua);
  }
  return false;
}

export function isAndroid(ua:string) {
  ua = ua || window.navigator.userAgent;
  return /Android/.test(ua);
}

export function isOperaMini(ua:string) {
  ua = ua || window.navigator.userAgent;
  return ua.indexOf('Opera Mini') > -1;
}

export function isMobileDevice(ua?:string){
  ua = ua || window.navigator.userAgent;
  return (/Android|webOS|iPhone|iPad|iPod|BB10|BlackBerry/i.test(ua))
}
export function isAndroidWebview(ua?:string) {
  let androidWebviewRegExp = /Version\/[\d\.]+/;
  ua = ua || window.navigator.userAgent;
  if (isAndroid(ua)) {
    return androidWebviewRegExp.test(ua) && !isOperaMini(ua);
  }
  return false;
}